import * as React from "react"
import { cn } from "@/utilities/ui"

interface UnderlineTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

export const UnderlineTextarea = React.forwardRef<HTMLTextAreaElement, UnderlineTextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        className={cn(
          "block w-full resize-none border-0 border-b border-gray-300 bg-transparent px-0 py-2 text-gray-900 placeholder:text-gray-400 focus:border-b-1 focus:border-[#8D8D8D] focus:outline-none focus:ring-0 sm:text-sm",
          className
        )}
        {...props}
      />
    )
  }
)

UnderlineTextarea.displayName = "UnderlineTextarea"